import { Link } from "@/src/components/nav/index";
import { TabConfig } from "@/src/components/nav/types";
import { useCallback } from "react";
import { PermissionCheck } from "../permissions/PermissionCheck";
import { FeatureFlag } from "../posthog/FeatureFlag";

interface TopTabNavbarProps {
  tabs: TabConfig[];
}

const DealNavbar = ({ tabs }: TopTabNavbarProps) => {
  const renderItem = useCallback(
    ({
      permissionCheck,
      label,
      icon,
      to,
      iconActiveColor,
      iconInactiveColor,
      ...config
    }: TabConfig, key: string) => {
      return (
        <Link
          key={key}
          margin="0 0 xs 0"
          to={to}
          iconActiveColor={iconActiveColor}
          iconInactiveColor={iconInactiveColor}
          {...config}
        >
          {({ isActive, iconActiveColor, iconInactiveColor }) => (
            <div className="flex items-center space-x-2">
              <div
                className={
                  isActive
                    ? iconActiveColor || "text-persian-300"
                    : iconInactiveColor || "text-persian-800"
                }
              >
                {icon}
              </div>
              <span className="text-sm font-semibold truncate">{label}</span>
            </div>
          )}
        </Link>
      );
    },
    [],
  );

  const renderTab = useCallback(
    (tabConfig: TabConfig) => {
      const key = `${tabConfig.to}-${objectToString(tabConfig.permissionCheck)}-${tabConfig.featureFlag ?? ""}`;

      let content = <li>{renderItem(tabConfig, key)}</li>;

      if (tabConfig.permissionCheck) {
        content = (
          <PermissionCheck input={tabConfig.permissionCheck}>
            {content}
          </PermissionCheck>
        );
      }

      if (tabConfig.featureFlag) {
        content = (
          <FeatureFlag key={key} flag={tabConfig.featureFlag}>
            {content}
          </FeatureFlag>
        );
      }

      return content;
    },
    [renderItem],
  );

  return (
    <nav className="transition-colors duration-300 ease-in-out gap-x-2 min-w-0 overflow-x-scroll no-scrollbar">
      <ul className={"flex flex-row gap-x-2"}>
        {tabs.map((tabConfig) => renderTab(tabConfig))}
      </ul>
    </nav>
  );
};
export default DealNavbar;

// Simple object to string function
export function objectToString(obj: Record<string, any> | undefined): string {
  if (obj === undefined) return "";
  if (obj === null) return "";
  if (typeof obj !== "object") return String(obj);
  try {
    return JSON.stringify(obj, null, 2);
  } catch {
    return String(obj);
  }
}
